import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./pages/shell/shell.component').then(m => m.ShellComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        loadComponent: () => import('./pages/home/home.component').then(m => m.HomeComponent),
      },
      {
        path: 'learn/:topicId',
        loadComponent: () => import('./pages/learn/learn.component').then(m => m.LearnComponent),
      },
      {
        path: 'tests',
        loadComponent: () => import('./pages/tests/tests.component').then(m => m.TestsComponent),
      },
      {
        path: 'tests/take/:topicId',
        loadComponent: () => import('./pages/test-take/test-take.component').then(m => m.TestTakeComponent),
      },
      {
        path: 'progress',
        loadComponent: () => import('./pages/progress/progress.component').then(m => m.ProgressComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
